import React from 'react';

const useIsKeyboardOpen = (minKeyboardHeight = 300, defaultValue?: boolean) => {
  const [isKeyboardOpen, setIsKeyboardOpen] = React.useState(defaultValue);

  React.useEffect(() => {
    const listener = () => {
      const newState =
        window.screen.height - minKeyboardHeight >
        (window.visualViewport?.height ?? Infinity);
      if (isKeyboardOpen !== newState) {
        setIsKeyboardOpen(newState);
      }
    };
    if (typeof visualViewport != 'undefined') {
      window.visualViewport?.addEventListener('resize', listener);
    }
    return () => {
      if (typeof visualViewport != 'undefined') {
        window.visualViewport?.removeEventListener('resize', listener);
      }
    };
  }, [isKeyboardOpen, minKeyboardHeight]);

  return isKeyboardOpen;
};

export const SoftKeyboardListener = () => {
  const isKeyboardOpen = useIsKeyboardOpen();
  React.useEffect(() => {
    if (isKeyboardOpen) {
      document.body.classList.add('keyboard-open');
      return;
    }
    // Clear on unmount: si no, el timer sobrevive al componente y en CI se
    // dispara después del teardown de jsdom (document ya no existe).
    const timer = setTimeout(
      () => document.body.classList.remove('keyboard-open'),
      10
    );
    return () => clearTimeout(timer);
  }, [isKeyboardOpen]);

  return null;
};

export default useIsKeyboardOpen;
